<div class="flex w-full flex-col gap-3">
    @for (item of wrappedItems; track item; let index = $index) {
        <div
            class="group relative rounded-lg border border-slate-200 bg-white p-4 transition-all hover:border-slate-300 hover:shadow-sm"
        >
            <!-- Item number indicator -->
            <div
                class="absolute top-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-xs font-semibold text-primary-700 ltr:left-3 rtl:right-3"
            >
                {{ index + 1 }}
            </div>
            <div
                class="flex flex-col gap-3 md:flex-row md:items-start ltr:pl-8 rtl:pr-8"
            >
                <div class="min-w-0 flex-1">
                    <ng-container
                        [ngTemplateOutlet]="itemTemplate"
                        [ngTemplateOutletContext]="{
                            item: item.item,
                            emitChange,
                            isDisabled,
                            index,
                        }"
                    ></ng-container>
                </div>
                @if (!isDisabled) {
                    <button
                        (click)="removeItem(item)"
                        [appTooltip]="'translate_delete' | translate"
                        type="button"
                        class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-400 transition-all hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
                    >
                        <i class="fa-light fa-trash-can text-sm"></i>
                    </button>
                }
            </div>
        </div>
    }
    @if (!isDisabled && showAddButton) {
        <div class="mt-1 flex justify-center">
            <button
                (click)="addItem()"
                type="button"
                class="inline-flex items-center gap-2 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-2.5 text-sm font-medium text-slate-600 transition-all hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
            >
                <i class="fa-light fa-plus"></i>
                <span>{{ 'translate_add' | translate }}</span>
            </button>
        </div>
    }
</div>
